var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Bar',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.options,"chart-id":_vm.id,"width":200,"height":30}})}
var staticRenderFns = []

export { render, staticRenderFns }